import React, { useState } from 'react';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';

// Correct import for PrimeIcons
const Home = () => {
    const cards = [
        {
            title: "Connect with Classmates",
            description: "Easily find and connect with your classmates and peers through the community app.",
            icon: "pi pi-users",
            gradient: "bg-gradient-to-r from-blue-500 to-teal-500",
        },
        {
            title: "Live Events & Workshops",
            description: "Join live webinars, events, and workshops tailored to your academic and personal growth.",
            icon: "pi pi-calendar",
            gradient: "bg-gradient-to-r from-purple-500 to-pink-500",
        },
        {
            title: "Discussion Forums",
            description: "Engage in discussions, ask questions, and share knowledge on relevant topics.",
            icon: "pi pi-comments",
            gradient: "bg-gradient-to-r from-green-500 to-cyan-500",
        },
        {
            title: "Career Guidance",
            description: "Get access to career counseling, guidance from alumni, and professional development resources.",
            icon: "pi pi-briefcase",
            gradient: "bg-gradient-to-r from-yellow-500 to-orange-500",
        },
    ];

    //  style={{ backgroundImage: "url('/assets/img/hero.jpg')", backgroundPosition: 'center right' }}
    return (

        <div className="relative overflow-hidden ">
            <section className="relative flex items-center justify-center min-h-screen overflow-hidden pb-16 bg-white dark:bg-slate-950 dark:text-white sm:mt-[-3rem] lg:mt-[-7rem]">
                <div className="absolute inset-0 hidden bg-cover opacity-5 dark:block"
                    style={{
                        backgroundImage: "url('/assets/images/globe.jpg')",
                        backgroundPosition: "center 25%" // Default position for smaller screens
                    }}>
                </div>

                <div className="relative grid grid-cols-1 gap-8 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 xl:gap-12 xl:mt-20">
                    <div className="flex flex-col justify-center text-center lg:pr-12">
                        <div className="mt-4 text-lg font-semibold leading-8 sm:text-xl md:text-2xl text-sky-600 dark:text-sky-600 sm:mt-6" aria-hidden="true">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-cyan-500">
                                Join Collegemate Community
                            </span>
                            - Connect With Your College Peers
                        </div>
                        <h1 className="mt-4 text-4xl tracking-tight text-center sm:text-5xl md:text-6xl lg:text-7xl text-slate-900 dark:text-white">
                            <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-cyan-600 animate-custom-pulse megabyte">
                                COLLEGEMATE COMMUNITY
                            </span>
                        </h1>

                        <p className="mt-6 text-sm text-left sm:text-base md:text-lg lg:text-lg text-slate-700 dark:text-slate-300 sm:ml-4 md:ml-8 lg:ml-12">
                            Collegemate Community brings students together from across the world to collaborate, share knowledge, and grow as a community. From academic discussions to career guidance, our platform provides the resources and connections you need to succeed.
                        </p>

                        <div className="flex flex-col items-center justify-center mt-8 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                            <div className="flex items-center justify-center mt-2 space-x-5">
                                <a href="https://play.google.com/store/apps/details?id=com.creativestarjsp.collegemate" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                        alt="Get it on Google Play"
                                        className="h-10 hover:opacity-75"
                                    />
                                </a>
                                {/* <a href="https://www.apple.com/ios/app-store/" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="/assets/images/apple.png"
                                        alt="Download on the App Store"
                                        className="h-10 hover:opacity-75"
                                    />
                                </a> */}
                            </div>
                        </div>

                    </div>

                </div>
                <div className="absolute bottom-0 left-0 z-0 w-full h-1/3" style={{ backgroundImage: 'linear-gradient(to right top, rgba(128, 0, 128, 0.2) 0%, transparent 50%, transparent 100%)' }}></div>
                <div className="absolute bottom-0 right-0 z-0 w-full h-1/3" style={{ backgroundImage: 'linear-gradient(to left top, rgba(0, 255, 255, 0.1) 0%, transparent 50%, transparent 100%)' }}></div>

            </section>








            <section class="relative py-6 bg-white dark:bg-slate-950 text-gray-800 dark:text-white">
                <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
                    <div class="container mx-auto px-6 p-6 bg-white dark:bg-slate-950">
                        <div class="mb-16 text-center">
                            <h2 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">
                                Discover Your Path
                            </h2>

                            <p class="mt-3 t  tracking-normal text-gray-500"> At Collegemate, we promote personal growth and help you connect with like-minded individuals.</p>



                        </div>



                        <div class="flex flex-wrap my-12">

                            <div class="w-full border-b md:w-1/2 md:border-r lg:w-1/3 p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Connect with Peers</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Join our vibrant community where students connect, collaborate, and build lifelong friendships.</p>
                            </div>

                            <div class="w-full border-b md:w-1/2 lg:w-1/3 lg:border-r p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Collaborate on Projects</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Work together on academic projects and gain insights from your peers to enhance learning experiences.</p>
                            </div>

                            <div class="w-full border-b md:w-1/2 md:border-r lg:w-1/3 lg:border-r-0 p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Participate in Events</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Engage in community events, workshops, and seminars to expand your knowledge and network.</p>
                            </div>

                            <div class="w-full border-b md:w-1/2 lg:w-1/3 lg:border-r lg:border-b-0 p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Build Lifelong Friendships</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Forge connections that last beyond college through our supportive and engaging community.</p>
                            </div>

                            <div class="w-full border-b md:w-1/2 md:border-r md:border-b-0 lg:w-1/3 lg:border-b-0 p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Access Resources</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Gain access to academic resources, mentorship, and study materials to excel in your studies.</p>
                            </div>

                            <div class="w-full border-b md:w-1/2 lg:w-1/3 lg:border-b-0 p-8">
                                <div class="flex items-center mb-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20" fill="currentColor" class="h-6 w-6 text-purple-500">
                                        <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z" />
                                    </svg>
                                    <div class="ml-4 text-xl font-semibold">Share Knowledge</div>
                                </div>
                                <p class="leading-loose text-gray-500 dark:text-gray-300">Share your knowledge and expertise while learning from others in the community.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>






            <section className="relative py-12 text-gray-800 bg-white dark:bg-slate-950 dark:text-white">
                <div className="px-6 mx-auto max-w-7xl lg:px-8">
                    <h2 className="text-3xl font-bold tracking-normal text-transparent uppercase sm:text-4xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-purple-700 to-cyan-500">
                        About CollegeMate Community
                    </h2>
                    <p className="mt-3 tracking-normal text-gray-500">
                        Join a vibrant community of students and alumni, dedicated to fostering connections and enhancing your collegemate experience.
                    </p>
                    <div className="grid grid-cols-1 gap-8 mt-8 lg:grid-cols-2">

                        <div className="lg:pr-8">
                            <dl className="mt-10 space-y-8">
                                <div className="relative pl-9">
                                    <dt className="flex items-center inline gap-2 text-lg font-semibold text-slate-900 dark:text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="text-purple-600 h-9 w-9">
                                            <path d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"></path>
                                            <path d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"></path>
                                            <path d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"></path>
                                        </svg>
                                        Community Focused
                                    </dt>
                                    <dd className="mt-2 text-base text-gray-400 text-start">
                                        We bring together students and alumni to foster a collaborative and supportive environment.
                                    </dd>
                                </div>


                                <div className="relative pl-9">
                                    <dt className="flex items-center inline gap-2 text-lg font-semibold text-slate-900 dark:text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="text-purple-600 h-9 w-9">
                                            <path fillRule="evenodd" d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z" clipRule="evenodd"></path>
                                        </svg>
                                        Networking Opportunities
                                    </dt>
                                    <dd className="mt-2 text-base text-gray-400 text-start">
                                        Connect with like-minded individuals and industry professionals to advance your career and studies.
                                    </dd>
                                </div>

                                <div className="relative pl-9">
                                    <dt className="flex items-center inline gap-2 text-lg font-semibold text-slate-900 dark:text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="text-purple-600 h-9 w-9">
                                            <path fillRule="evenodd" d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z" clipRule="evenodd"></path>
                                        </svg>
                                        Professional Development
                                    </dt>
                                    <dd className="mt-2 text-base text-gray-400 text-start">
                                        Participate in workshops and events that enhance your skills and knowledge.
                                    </dd>
                                </div>


                                <div className="relative pl-9">
                                    <dt className="flex items-center inline gap-2 text-lg font-semibold text-slate-900 dark:text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="text-purple-600 h-9 w-9">
                                            <path d="M10 2a1 1 0 00-1 1v1.5a3.5 3.5 0 00-3 3.5v8a1 1 0 001 1h10a1 1 0 001-1v-8a3.5 3.5 0 00-3-3.5V3a1 1 0 00-1-1H10zm1 4h2.5a1 1 0 011 1v1.5h-4V6a1 1 0 011-1zm-6 6.5h9V10h-9v2.5zM4 12h10v4H4v-4z"></path>
                                        </svg>
                                        Course Offerings
                                    </dt>
                                    <dd className="mt-2 text-base text-gray-400 text-start">
                                        Explore a wide range of courses tailored to enhance your skills and knowledge across various fields.
                                    </dd>
                                </div>


                                <div className="relative pl-9">
                                    <dt className="flex items-center inline gap-2 text-lg font-semibold text-slate-900 dark:text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="text-purple-600 h-9 w-9">
                                            <path d="M10 1a9 9 0 100 18 9 9 0 000-18zM9 4h2v2H9V4zm0 3h2v6H9V7zm3 0h2v6h-2V7z"></path>
                                        </svg>
                                        Continuous Learning
                                    </dt>
                                    <dd className="mt-2 text-base text-gray-400 text-start">
                                        Join various learning sessions and webinars to stay updated with the latest trends and technologies.
                                    </dd>
                                </div>
                            </dl>

                            <div className="flex flex-col items-center gap-4 mt-10 lg:items-start">

                                <a
                                    href="https://whatsapp.com/channel/0029Vb1l0Tm6mYPOb9GJ8I09"
                                    className="px-6 py-3 text-base font-semibold text-purple-600 transition duration-300 ease-in-out transform border border-purple-600 rounded-md shadow-md hover:bg-purple-100 hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Join Us Today
                                </a>

                            </div>

                        </div>

                        <div className="flex w-full mt-3 justify-right lg:justify-right">
                            <div className="relative flex-1 hidden md:flex">
                                <div className="absolute top-0 right-0 w-3/4 h-full">
                                    <img src="/assets/images/1.png" alt="Phone 1" className="absolute top-0 right-0 object-contain w-full h-full" />
                                </div>
                                <div className="absolute bottom-0 left-0 w-3/4 h-5/6">
                                    <img src="/assets/images/2.png" alt="Phone 2" className="absolute bottom-0 left-0 object-contain w-full h-full" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="relative py-12 text-gray-800 bg-white dark:bg-slate-950 dark:text-gray-100">
                <div className="w-full px-4 mx-auto text-center max-w-7xl md:px-5 lg:px-8">
                    <h2 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">FEATURES YOU'LL LOVE</h2>
                    <p className="max-w-md mx-auto mt-4 text-gray-500 dark:text-gray-400">
                        Community,Opportunities,Collabration and Success
                    </p>

                    <div class="grid md:grid-cols-2 gap-5 mt-10 ">

                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
                                    <path d="M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM11.75 12.35H12.35H12.65H13.25V13.25H12.65H12.35H11.75V12.65V12.35Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Courses</h3>
                                <p class="mt-1 text-gray-500 text-start">Explore a diverse range of expert-led courses tailored to help you excel in your career.</p>
                            </div>
                        </div>


                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5"><path d="M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg></span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Placements</h3>
                                <p class="mt-1 text-gray-500 text-start">Secure your dream job with our dedicated placement support and resources.</p>
                            </div>
                        </div>


                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
                                    <path d="M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>
                                </svg>
                            </span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Community</h3>
                                <p class="mt-1 text-gray-500 text-start">Join a thriving community.</p>
                            </div>
                        </div>



                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
                                    <path d="M7.5 0C3.357 0 0 3.357 0 7.5C0 11.643 3.357 15 7.5 15C11.643 15 15 11.643 15 7.5C15 3.357 11.643 0 7.5 0ZM11.25 9.375L9.375 11.25L6.75 8.625L4.125 11.25L2.25 9.375L6.75 4.875L9.375 7.5L11.25 5.625L13.125 7.5L11.25 9.375ZM6.75 6.75L4.125 9.375L3.75 9.75L4.125 10.125L6.75 7.5L9.375 10.125L9 9.75L6.75 7.5L6.75 6.75Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Mentorship</h3>
                                <p class="mt-1 text-gray-500 text-start">Get personalized mentorship from industry experts to guide your career journey.</p>
                            </div>
                        </div>
                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5"><path d="M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg></span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Circles</h3>
                                <p class="mt-1 text-gray-500 text-start">Our platform fosters dynamic network circles, enabling seamless connections and collaboration within your community.</p>
                            </div>

                        </div>
                        <div class="flex gap-4 items-start">
                            <span class="text-violet-600 bg-violet-500/10 p-3 rounded-full">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
                                    <path d="M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>
                                </svg>
                            </span>
                            <div>
                                <h3 class="font-semibold text-xl text-start">Opportunities</h3>
                                <p class="mt-1 text-gray-500 text-start">Unlock potential.</p>
                            </div>
                        </div>

                    </div>



                </div>
            </section>

            <section id="features" className="relative block px-6 py-10 text-gray-800 bg-white md:py-20 md:px-10 dark:bg-slate-950 dark:text-white">
                <div className="relative max-w-5xl mx-auto text-center">
                    <h2 className="text-3xl font-bold tracking-normal text-transparent uppercase sm:text-4xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-purple-700 to-cyan-500">
                        What Makes Us Unique
                    </h2>
                    <p className="max-w-md mx-auto mt-4 text-gray-500 dark:text-gray-400">
                        The CollegeMate platform empowers you to connect, learn, and grow in a thriving community.
                    </p>
                </div>

                <div className="relative z-10 grid grid-cols-1 gap-10 mx-auto max-w-7xl pt-14 sm:grid-cols-2 lg:grid-cols-3">

                    <div className="p-4 text-center transition-transform transform bg-white border border-gray-200 rounded-lg shadow-lg dark:border-gray-600 dark:bg-slate-950 hover:scale-105">
                        <div className="flex items-center justify-center w-10 h-10 mx-auto bg-purple-500 border-0 rounded-md button-text">
                            <i className="pi pi-palette" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <h3 className="mt-6 text-2xl font-semibold text-gray-800 dark:text-gray-200">Diverse Courses</h3>
                        <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-gray-600 dark:text-gray-400">
                            Explore a wide array of courses tailored to equip you with the skills required in today's competitive job market. Our programs not only enhance your knowledge but also prepare you for placements in esteemed companies.
                        </p>
                    </div>


                    <div className="p-4 text-center transition-transform transform bg-white border border-gray-200 rounded-lg shadow-lg dark:border-gray-600 dark:bg-slate-950 hover:scale-105">
                        <div className="flex items-center justify-center w-10 h-10 mx-auto bg-purple-500 border-0 rounded-md button-text">
                            <i className="pi pi-users" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <h3 className="mt-6 text-2xl font-semibold text-gray-800 dark:text-gray-200">Alumni Network</h3>
                        <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-gray-600 dark:text-gray-400">
                            Connect with a global alumni network. Benefit from mentorship, career guidance, and job referrals from successful graduates who understand your journey.
                        </p>
                    </div>


                    <div className="p-4 text-center transition-transform transform bg-white border border-gray-200 rounded-lg shadow-lg dark:border-gray-600 dark:bg-slate-950 hover:scale-105">
                        <div className="flex items-center justify-center w-10 h-10 mx-auto bg-purple-500 border-0 rounded-md button-text">
                            <i className="pi pi-calendar" style={{ fontSize: '24px', color: 'white' }}></i>
                        </div>
                        <h3 className="mt-6 text-2xl font-semibold text-gray-800 dark:text-gray-200">Engaging Events</h3>
                        <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-gray-600 dark:text-gray-400">
                            Stay updated with exciting campus events, hackathons, guest lectures, and networking opportunities. Participate to enrich your college experience and build valuable connections.
                        </p>
                    </div>
                </div>
            </section>






            <section class="relative overflow-hidden bg-white dark:bg-slate-950">
                <div class="mt-2 md:mt-0 py-12 pb-6 sm:py-16 lg:pb-24 overflow-hidden">
                    <h2 className="text-3xl font-bold tracking-normal text-center text-transparent uppercase sm:text-4xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-purple-700 to-cyan-500">
                        HOW ITS WORKS
                    </h2>
                    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 relative">
                        <div class="relative mt-12 lg:mt-20">
                            <div class="absolute inset-x-0 hidden xl:px-44 top-2 md:block md:px-20 lg:px-28">
                                <svg class="w-full" xmlns="http://www.w3.org/2000/svg" width="875" height="48" viewBox="0 0 875 48"
                                    fill="none">
                                    <path
                                        d="M2 29C20.2154 33.6961 38.9915 35.1324 57.6111 37.5555C80.2065 40.496 102.791 43.3231 125.556 44.5555C163.184 46.5927 201.26 45 238.944 45C312.75 45 385.368 30.7371 458.278 20.6666C495.231 15.5627 532.399 11.6429 569.278 6.11109C589.515 3.07551 609.767 2.09927 630.222 1.99998C655.606 1.87676 681.208 1.11809 706.556 2.44442C739.552 4.17096 772.539 6.75565 805.222 11.5C828 14.8064 850.34 20.2233 873 24"
                                        stroke="#D4D4D8" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 12" />
                                </svg>
                            </div>
                            <div
                                class="relative grid grid-cols-1 text-center gap-y-8 sm:gap-y-10 md:gap-y-12 md:grid-cols-3 gap-x-12">
                                <div>
                                    <div
                                        class="flex items-center justify-center w-16 h-16 mx-auto bg-white dark:bg-gray-800 border-2 border-purple-700 dark:border-purple-700 rounded-full shadow">
                                        <span class="text-xl font-semibold text-gray-700 dark:text-gray-200">1</span>
                                    </div>
                                    <h3
                                        class="mt-4 sm:mt-6 text-xl font-semibold leading-tight text-gray-900 dark:text-white md:mt-10">
                                        Register
                                    </h3>
                                    <p class="mt-3 sm:mt-4 text-base text-gray-600 dark:text-gray-400">
                                        Register with your email or using sign up with goolgle
                                    </p>
                                </div>
                                <div>
                                    <div
                                        class="flex items-center justify-center w-16 h-16 mx-auto bg-white dark:bg-gray-800 border-2 border-purple-700 dark:border-purple-700 rounded-full shadow">
                                        <span class="text-xl font-semibold text-gray-700 dark:text-gray-200">2</span>
                                    </div>
                                    <h3
                                        class="mt-4 sm:mt-6 text-xl font-semibold leading-tight text-gray-900 dark:text-white md:mt-10">
                                        Join the Community
                                    </h3>
                                    <p class="mt-3 sm:mt-4 text-base text-gray-600 dark:text-gray-400">
                                        Explore a variety of events, workshops, and networking opportunities tailored for students.
                                    </p>
                                </div>
                                <div>
                                    <div
                                        class="flex items-center justify-center w-16 h-16 mx-auto bg-white dark:bg-gray-800 border-2 border-purple-700 dark:border-purple-700 rounded-full shadow">
                                        <span class="text-xl font-semibold text-gray-700 dark:text-gray-200">3</span>
                                    </div>
                                    <h3
                                        class="mt-4 sm:mt-6 text-xl font-semibold leading-tight text-gray-900 dark:text-white md:mt-10">
                                        Connect & Collaborate
                                    </h3>
                                    <p class="mt-3 sm:mt-4 text-base text-gray-600 dark:text-gray-400">
                                        Join discussions and collaborate with peers on projects and ideas through our platform.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


















            <section className="relative py-24 bg-white dark:bg-slate-950">
                <div className="w-full px-4 mx-auto max-w-7xl md:px-5 lg:px-5">
                    <div className="grid items-center w-full grid-cols-1 gap-12 lg:grid-cols-2">


                        <div className="flex justify-center w-full lg:justify-start">
                            <img
                                className="rounded-xl object-cover w-full lg:w-[120%] h-auto"
                                src="/assets/images/vector.png"
                                alt="About CollegemateCommunity"
                            />
                        </div>


                        <div className="flex flex-col items-center justify-center w-full gap-10 lg:items-start">
                            <div className="flex flex-col items-start justify-center w-full gap-8">
                                <div className="flex flex-col items-center justify-start w-full gap-3 lg:items-start">
                                    <h2 className="text-3xl font-bold tracking-normal text-left text-transparent uppercase sm:text-4xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-purple-700 to-cyan-500">
                                        EMPOWERING COLLEGE SUCCESS
                                    </h2>
                                    <p className="text-base font-normal leading-relaxed text-center text-gray-500 dark:text-gray-300 lg:text-start">
                                        Collegemate Community is a platform that connects students, fosters collaboration, and enhances learning experiences through shared resources and community engagement.
                                    </p>
                                </div>


                                <div className="grid justify-center w-full grid-cols-1 gap-5 sm:grid-cols-4 sm:gap-10">
                                    <div className="flex flex-col items-center p-4 text-center transition-transform duration-300 transform bg-white rounded-lg shadow-lg hover:scale-105 hover:shadow-xl hover:shadow-purple-500/50 dark:bg-slate-950">
                                        <h3 className="text-4xl font-bold leading-normal text-gray-900 dark:text-white font-manrope">
                                            100+
                                        </h3>
                                        <h6 className="text-base font-normal leading-relaxed text-gray-500 dark:text-gray-300">
                                            Courses
                                        </h6>
                                    </div>
                                    <div className="flex flex-col items-center p-4 text-center transition-transform duration-300 transform bg-white rounded-lg shadow-lg hover:scale-105 hover:shadow-xl hover:shadow-purple-500/50 dark:bg-slate-950">
                                        <h3 className="text-4xl font-bold leading-normal text-gray-900 dark:text-white font-manrope">
                                            200+
                                        </h3>
                                        <h6 className="text-base font-normal leading-relaxed text-gray-500 dark:text-gray-300">
                                            Events
                                        </h6>
                                    </div>
                                    <div className="flex flex-col items-center p-4 text-center transition-transform duration-300 transform bg-white rounded-lg shadow-lg hover:scale-105 hover:shadow-xl hover:shadow-purple-500/50 dark:bg-slate-950">
                                        <h3 className="text-4xl font-bold leading-normal text-gray-900 dark:text-white font-manrope">
                                            200+
                                        </h3>
                                        <h6 className="text-base font-normal leading-relaxed text-gray-500 dark:text-gray-300">
                                            Clubs
                                        </h6>
                                    </div>
                                    <div className="flex flex-col items-center p-4 text-center transition-transform duration-300 transform bg-white rounded-lg shadow-lg hover:scale-105 hover:shadow-xl hover:shadow-purple-500/50 dark:bg-slate-950">
                                        <h3 className="text-4xl font-bold leading-normal text-gray-900 dark:text-white font-manrope">
                                            5000+
                                        </h3>
                                        <h6 className="text-base font-normal leading-relaxed text-gray-500 dark:text-gray-300">
                                            Opportunities
                                        </h6>
                                    </div>
                                </div>

                            </div>

                            <button class="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800">
                                <span class="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                                    Explore the CollegeMate Community
                                </span>
                            </button>


                        </div>
                    </div>
                </div>
            </section>


            <div className="py-20 text-gray-800 bg-white dark:bg-slate-950 dark:text-gray-100">
                <div className="px-6 mx-auto max-w-7xl lg:px-8">
                    <div className="max-w-2xl mx-auto text-center">
                        <h2 className="text-3xl font-bold tracking-normal text-center text-transparent uppercase sm:text-4xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-purple-700 to-cyan-500"> OUR COURSES</h2>
                        <p className="mt-2 text-lg leading-8">
                            Explore our comprehensive courses and enhance your skills.
                        </p>
                    </div>
                    <div className="grid max-w-2xl grid-cols-1 gap-8 mx-auto mt-8 sm:mt-12 lg:mx-0 lg:max-w-none lg:grid-cols-4">

                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2021/08/04/13/06/software-developer-6521720_640.jpg"
                                alt="AI Fundamentals"
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center text-xs leading-5 text-gray-300 gap-y-2 sm:text-sm">
                                <time dateTime="2024-06-12" className="mr-6">
                                    <strong>Posted</strong> on June 12, 2024
                                </time>
                                <div className="flex items-center gap-x-3">
                                    <svg viewBox="0 0 2 2" className="flex-none w-1 h-1 -ml-1 fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex items-center gap-x-2">
                                        <img
                                            src="https://randomuser.me/api/portraits/men/2.jpg"
                                            alt="John"
                                            className="w-8 h-8 rounded-full bg-white/10"
                                        />
                                        <span className="text-sm text-white sm:text-base">John</span>
                                    </div>
                                </div>
                            </div>
                            <h3 className="mt-2 text-base font-semibold leading-6 text-white sm:text-lg">
                                <a href="#" className="hover:underline">
                                    <span className="absolute inset-0"></span>Artificial Intelligence Fundamentals
                                </a>
                            </h3>
                        </article>



                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2020/10/21/18/07/laptop-5673901_640.jpg"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-09-01" className="mr-8"> <strong>Posted</strong> on Sep 01, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/women/2.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        Jack
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Blockchain Technology Basics</a>
                            </h3>
                        </article>


                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2024/01/29/22/47/ai-generated-8540921_1280.jpg"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-08-21" className="mr-8"> <strong>Posted</strong> on Aug 21, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/men/3.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        layana
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Quantum Computing Overview</a>
                            </h3>
                        </article>


                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2024/02/08/02/53/digital-8560051_1280.jpg"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-01-19" className="mr-8"> <strong>Posted</strong> on jan 19, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/women/1.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        Sarah
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Data Science Mastery</a>
                            </h3>
                        </article>
                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2024/02/28/17/16/ai-generated-8602502_1280.jpg"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-02-10" className="mr-8"> <strong>Posted</strong> on Feb 10, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/men/2.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        Kiran
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Frontend Developer</a>
                            </h3>
                        </article>
                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://cdn.pixabay.com/photo/2018/05/08/08/44/artificial-intelligence-3382507_640.jpg"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-09-11" className="mr-8"> <strong>Posted</strong> on Sep 11, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/men/2.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        Reheman
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Data Analyst</a>
                            </h3>
                        </article>

                        <article className="relative flex flex-col justify-end px-4 py-4 pt-64 pb-8 overflow-hidden bg-gray-900 isolate rounded-xl dark:bg-gray-700 sm:px-6 sm:py-6 md:px-8 md:py-8 sm:pt-48 lg:pt-40">
                            <img
                                src="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=600"
                                alt=""
                                className="absolute inset-0 object-cover w-full h-full -z-10"
                            />
                            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                            <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
                            <div className="flex flex-wrap items-center overflow-hidden text-sm leading-6 text-gray-300 gap-y-1">
                                <time datetime="2024-07-16" className="mr-8"> <strong>Posted</strong> on Jul 16, 2024</time>
                                <div className="flex items-center -ml-4 gap-x-4">
                                    <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                                        <circle cx="1" cy="1" r="1"></circle>
                                    </svg>
                                    <div className="flex gap-x-2.5">
                                        <img src="https://randomuser.me/api/portraits/men/2.jpg" alt="" className="flex-none w-10 h-10 rounded-full bg-white/10" />
                                        Deepika
                                    </div>
                                </div>
                                <button className="ml-auto">

                                </button>
                            </div>
                            <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                                <a href="#"><span className="absolute inset-0"></span>Full Stack Developer</a>
                            </h3>
                        </article>
                    </div>
                </div>
            </div>



















            <section id="testimonies" class="py-20 bg-white dark:bg-slate-950 text-gray-800 dark:text-gray-100">
                <div class="max-w-6xl mx-8 md:mx-10 lg:mx-20 xl:mx-auto">


                    <div class="transition duration-500 ease-in-out transform scale-100 translate-x-0 translate-y-0 opacity-100">
                        <div class="mb-12 space-y-5 md:mb-16 md:text-center">

                            <h1 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">
                                The Voice of Our Community
                            </h1>
                            <p class="text-gray-500 dark:text-gray-300 text-base font-normal leading-relaxed lg:text-center text-center">
                                Discover what our users have to say about their experience with Collegemate.
                            </p>
                        </div>
                    </div>


                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">


                        <ul class="space-y-8">
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=400"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Kanye West" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Supritha</h3>
                                                    <p class="text-gray-500 text-md">Rapper &amp; Entrepreneur</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">Good ,Highly recommend it to any student.</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://pbs.twimg.com/profile_images/1535420431766671360/Pwq-1eJc_400x400.jpg"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Tim Cook" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Samartha Nair</h3>
                                                    <p class="text-gray-500 text-md">Computer Science Major</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">As a techie, I appreciate the collaborative tools CollegeMate offers. I've been able to join coding groups and participate in hackathons, which have really enhanced my learning experience!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>

                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://images.pexels.com/photos/1197132/pexels-photo-1197132.jpeg?auto=compress&cs=tinysrgb&w=400"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Tim Cook" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Mrinal</h3>
                                                    <p class="text-gray-500 text-md">Aspiring Entrepreneur</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">The mentorship opportunities in CollegeMate have been invaluable. I’ve connected with industry professionals who are guiding me in my career path.</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                        </ul>


                        <ul class=" space-y-8 sm:block">
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://pbs.twimg.com/profile_images/1375285353146327052/y6jeByyD_400x400.jpg"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Parag Agrawal" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Parag Yashwant</h3>
                                                    <p class="text-gray-500 text-md">Psychology Student</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">CollegeMate is a great way to make friends and find study groups. I've met some amazing people through the app, and it’s nice to have a community that understands the challenges of college life</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://pbs.twimg.com/profile_images/1535420431766671360/Pwq-1eJc_400x400.jpg"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Tim Cook" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Mithun ahad</h3>
                                                    <p class="text-gray-500 text-md"> Web Developer</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">CollegeMate has been a game-changer for my coding journey. I found mentors and peers to collaborate on projects, and the resources shared by the community have significantly improved my skills!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://pbs.twimg.com/profile_images/1375285353146327052/y6jeByyD_400x400.jpg"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Parag Agrawal" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Ava Smith</h3>
                                                    <p class="text-gray-500 text-md">Information Technology Student</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">I love how CollegeMate connects IT students with industry professionals. The networking opportunities and tech talks organized through the app have opened doors for internships and job offers!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>

                        </ul>


                        <ul class="hidden space-y-8 lg:block">
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://images.pexels.com/photos/1212984/pexels-photo-1212984.jpeg?auto=compress&cs=tinysrgb&w=400"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Satya Nadella" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Noah John</h3>
                                                    <p class="text-gray-500 text-md">Cybersecurity Major</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">The cybersecurity discussions on CollegeMate are enlightening! I’ve learned so much about current trends and threats in the industry. It's an essential app for anyone serious about a career in IT!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://pbs.twimg.com/profile_images/516916920482672641/3jCeLgFb_400x400.jpeg"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Dan Schulman" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Sandeep</h3>
                                                    <p class="text-gray-500 text-md">Software Engineering Student</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">CollegeMate has helped me find study groups for software engineering courses. The resources and coding challenges shared in the community have been incredibly helpful for exam preparation!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li class="text-sm leading-6">
                                <div class="relative group">
                                    <div
                                        class="absolute transition rounded-lg opacity-25 -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur duration-400 group-hover:opacity-100 group-hover:duration-200">
                                    </div><a href="#" class="cursor-pointer">
                                        <div
                                            class="relative p-6 space-y-6 leading-none rounded-lg bg-slate-950 ring-1 ring-gray-900/5">
                                            <div class="flex items-center space-x-4"><img
                                                src="https://images.pexels.com/photos/1212984/pexels-photo-1212984.jpeg?auto=compress&cs=tinysrgb&w=400"
                                                class="w-12 h-12 bg-center bg-cover border rounded-full" alt="Satya Nadella" />
                                                <div>
                                                    <h3 class="text-lg font-semibold text-white">Preetam singh</h3>
                                                    <p class="text-gray-500 text-md">Data Science Enthusiast</p>
                                                </div>
                                            </div>
                                            <p class="leading-normal text-gray-300 text-md">The data science community on CollegeMate is fantastic! I've been able to work on real-life data projects with my peers and enhance my skills. The collaborative environment is unmatched!</p>
                                        </div>
                                    </a>
                                </div>
                            </li>

                        </ul>


                    </div>
                </div>
            </section>








            <section class="relative min-h-screen py-8 bg-white dark:bg-slate-950 text-gray-800 dark:text-gray-100" id='contactsection'>
                <div class="max-w-screen-xl mx-auto px-8">

                    <h2 class="text-3xl mr-7 sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">
                        GET IN TOUCH
                    </h2>


                    <div class=" mt-5 grid grid-cols-1 md:grid-cols-12 gap-8">

                        <div class="bg-slate-950 md:col-span-5 p-10 text-white rounded-lg shadow-lg">
                            <p class="leading-7 text-gray-200 text-start">
                                The Collegemate community fosters connections among diverse students, enhancing learning and creating lifelong friendships for a more enriching college experience.
                            </p>

                            <div class="flex flex-col mt-10">
                                <div class="flex items-center justify-start mt-5">
                                    <i class="pi pi-map-marker h-4 mr-2 text-indigo-600"></i>
                                    <span class="text-lg sm:text-base text-gray-200">Bangalore, India</span>
                                </div>
                                <div class="flex items-center justify-start mt-5">
                                    <i class="pi pi-phone h-4 mr-2 text-indigo-600"></i>
                                    <span class="text-lg sm:text-base text-gray-200">+91-8105827558</span>
                                </div>
                                <div class="flex items-center justify-start mt-5">
                                    <i class="pi pi-envelope h-3 mr-2 text-indigo-600"></i>
                                    <span class="text-lg sm:text-base text-gray-200">support@collegemate.io</span>
                                </div>
                            </div>

                        </div>


                        <div class="md:col-span-7 p-10  rounded-lg shadow-lg">
                            <form>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-200 text-start">Name</label>
                                        <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition ease-in-out duration-200 hover:border-cyan-500" placeholder="Your Name" />
                                    </div>
                                    <div>
                                        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-200 text-start">Email</label>
                                        <input type="email" class="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition ease-in-out duration-200 hover:border-cyan-500" placeholder="Your Email" />
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <label class="block mb-2 text-sm font-semibold text-gray-900 dark:text-gray-200 text-start">Message</label>
                                    <textarea class="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition ease-in-out duration-200 hover:border-cyan-500" placeholder="Your Message" rows="6"></textarea>
                                </div>
                                <div class="mt-6">
                                    <button type="submit" class="w-full px-6 py-3 text-white bg-gradient-to-r from-purple-500 to-cyan-500 rounded-md shadow-md hover:bg-gradient-to-r hover:from-cyan-500 hover:to-purple-500 focus:outline-none focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50 transition-transform transform hover:scale-105 duration-300">
                                        Send Message
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>


            <div class="relative isolate overflow-hidden bg-custom">
                <div class="py-24 px-8 max-w-5xl mx-auto flex flex-col md:flex-row gap-12 " id='faq'>
                    <div class="flex flex-col text-left basis-1/2">

                        <p class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">Frequently Asked Questions</p>
                    </div>
                    <ul class="basis-1/2">
                        <li class='group'>
                            <button class="relative  flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10" aria-expanded="false">
                                <span class="flex-1 text-base-content">What is the Collegemate Community App?</span>
                                <svg class="flex-shrink-0 w-4 h-4  ml-auto fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" rx="1" class="transform origin-center transition duration-200 ease-out false"></rect>
                                    <rect y="7" width="16" height="2" rx="1" class="block group-hover:opacity-0 origin-center rotate-90 transition duration-200 ease-out false"></rect>
                                </svg>
                            </button>
                            <div class="transition-all duration-300 ease-in-out group-hover:max-h-60 max-h-0 overflow-hidden text-gray-500" style={{ transition: "max-height 0.3s ease-in-out 0s" }}>
                                <div class="pb-5 leading-relaxed">
                                    <div class="space-y-2 leading-relaxed"> The Collegemate Community App is a platform designed to connect students, providing a space for collaboration, mentorship, and sharing resources for academic and career growth.</div>
                                </div>
                            </div>
                        </li>
                        <li class='group'>
                            <button class="relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10" aria-expanded="false">
                                <span class="flex-1 text-base-content">How do I join the Collegemate community?</span>
                                <svg class="flex-shrink-0 w-4 h-4 ml-auto fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" rx="1" class="transform origin-center transition duration-200 ease-out false"></rect>
                                    <rect y="7" width="16" height="2" rx="1" class="group-hover:opacity-0 transform origin-center rotate-90 transition-all duration-200 ease-out false"></rect>
                                </svg>
                            </button>
                            <div class="transition-all duration-300 ease-in-out group-hover:max-h-60 max-h-0 overflow-hidden text-gray-500" style={{ transition: "max-height 0.3s ease-in-out 0s" }}>
                                <div class="pb-5 leading-relaxed">
                                    <div class="space-y-2 leading-relaxed">You can join by downloading the app from the App Store or Google Play, signing up with your school email, and following the verification process.</div>
                                </div>
                            </div>
                        </li>
                        <li class='group'>
                            <button class="relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10" aria-expanded="false">
                                <span class="flex-1 text-base-content">What features does the app offer?</span>
                                <svg class="flex-shrink-0 w-4 h-4 ml-auto fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" rx="1" class="transform origin-center transition duration-200 ease-out false"></rect>
                                    <rect y="7" width="16" height="2" rx="1" class="group-hover:opacity-0 transform origin-center rotate-90 transition duration-200 ease-out false"></rect>
                                </svg>
                            </button>
                            <div class="transition-all duration-300 ease-in-out group-hover:max-h-60 max-h-0 overflow-hidden text-gray-500" style={{ transition: "max-height 0.3s ease-in-out 0s" }}>
                                <div class="pb-5 leading-relaxed">
                                    <div class="space-y-2 leading-relaxed"> The app offers forums, mentorship programs, resource libraries, study groups, job boards, and networking opportunities with fellow students and alumni.</div>
                                </div>
                            </div>
                        </li>
                        <li class='group'>
                            <button class="relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10" aria-expanded="false">
                                <span class="flex-1 text-base-content">Is the app free to use?</span>
                                <svg class="flex-shrink-0 w-4 h-4 ml-auto fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" rx="1" class="transform origin-center transition duration-200 ease-out false"></rect>
                                    <rect y="7" width="16" height="2" rx="1" class="group-hover:opacity-0 transform origin-center rotate-90 transition duration-200 ease-out false"></rect>
                                </svg>
                            </button>
                            <div class="transition-all duration-300 ease-in-out group-hover:max-h-60 max-h-0 overflow-hidden text-gray-500" style={{ transition: "max-height 0.3s ease-in-out 0s" }}>
                                <div class="pb-5 leading-relaxed">
                                    <div class="space-y-2 leading-relaxed"> Yes, the Collegemate Community App is free to use, although some premium features may require a subscription.</div>
                                </div>
                            </div>
                        </li>
                        <li class='group'>
                            <button class="relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-base-content/10" aria-expanded="false">
                                <span class="flex-1 text-base-content">How can I find mentors or study groups on the app?</span>
                                <svg class="flex-shrink-0 w-4 h-4 ml-auto fill-current" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" rx="1" class="transform origin-center transition duration-200 ease-out false"></rect>
                                    <rect y="7" width="16" height="2" rx="1" class="group-hover:opacity-0 transform origin-center rotate-90 transition duration-200 ease-out false"></rect>
                                </svg>
                            </button>
                            <div class="transition-all duration-300 ease-in-out group-hover:max-h-60 max-h-0 overflow-hidden text-gray-500" style={{ transition: "max-height 0.3s ease-in-out 0s" }}>
                                <div class="pb-5 leading-relaxed">
                                    <div class="space-y-2 leading-relaxed"> You can use the 'Mentorship' and 'Groups' sections within the app to browse available mentors or join study groups that match your interests and goals.</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a href="#contactsection" class='text-purple-500 mt-3 inline-flex font-medium no-underline group px-2 py-2 items-center -tracking-tight'>
                                Still Have a Question ? Contact Our Support
                                <svg class='w-5 h-5 group-hover:translate-x-1 transition-transform duration-500 ease-in-out' viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M78.1233 27.7777H21.8758C20.1259 27.7777 18.751 26.5555 18.751 24.9999C18.751 23.4444 20.1259 22.2222 21.8758 22.2222H78.1233C79.8732 22.2222 81.2482 23.4444 81.2482 24.9999C81.2482 26.5555 79.8732 27.7777 78.1233 27.7777Z" fill="#FF8E26" />
                                    <path d="M62.4999 47.2222C62.09 47.2266 61.6837 47.1548 61.307 47.0112C60.9302 46.8677 60.5915 46.6557 60.3125 46.3888C59.0625 45.2777 59.0625 43.5555 60.3125 42.4444L79.9991 24.9444L60.3125 7.4444C59.0625 6.33329 59.0625 4.61107 60.3125 3.49996C61.5624 2.38885 63.4998 2.38885 64.7498 3.49996L86.6238 22.9444C87.8737 24.0555 87.8737 25.7777 86.6238 26.8888L64.7498 46.3333C64.1248 46.8888 63.3123 47.1666 62.5624 47.1666L62.4999 47.2222Z" fill="#FF8E26" />
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <section class="container mx-auto my-20 py-20 bg-white dark:bg-slate-950 text-gray-800 dark:text-gray-100 rounded-lg text-center">
                <h3 class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold uppercase tracking-normal bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-cyan-500">Join the Collegemate Community!</h3>
                <p class="max-w-md mx-auto mt-4 text-gray-500 dark:text-gray-400">
                    Connect with fellow students, share experiences, and grow together.
                    Engage in discussions, collaborate on projects, and make lifelong friends.
                </p>

                <div class="relative inline-flex items-center justify-center gap-4 group mt-10">
                    <div
                        class="absolute inset-0 duration-1000 opacity-60 transition-all bg-gradient-to-r from-indigo-500 via-pink-500 to-yellow-400 rounded-xl blur-lg filter group-hover:opacity-100 group-hover:duration-200">
                    </div>
                    <a href="#contactsection"
                        class="group relative inline-flex items-center justify-center text-base rounded-xl bg-slate-950 px-8 py-3 font-semibold text-white transition-all duration-200 hover:bg-gray-800 hover:shadow-lg hover:-translate-y-0.5 hover:shadow-gray-600/30"
                        role="button">Get Started For Free<svg class="mt-0.5 ml-2 -mr-1 stroke-white stroke-2" fill="none" width="10"
                            height="10" viewBox="0 0 10 10" aria-hidden="true">
                            <path class="transition opacity-0 group-hover:opacity-100" d="M0 5h7"></path>
                            <path class="transition group-hover:translate-x-[3px]" d="M1 1l4 4-4 4"></path>
                        </svg>
                    </a>
                </div>

            </section>






        </div>







    );
};

export default Home;
